// extracted by mini-css-extract-plugin
export var copy = "quote-module--copy--ec9d4";
export var ctaLink = "quote-module--cta-link--ea732";
export var eyebrow = "quote-module--eyebrow--8bafa";
export var quote = "quote-module--quote--68bfc";
export var quoteCopy = "quote-module--quote-copy--20747";
export var quoteIcon = "quote-module--quote-icon--ace2b";
export var quoteSignature = "quote-module--quote-signature--28212";